<template>
    <footer class="the-footer">
        <div class="footer-inner">
            <div class="footer-main">
                <div class="footer-col">
                    <h4>{{ $t('footer.quickLinks') }}</h4>
                    <div class="quick-links">
                        <div class="links-row">
                            <span v-for="link in quickLinksRow1" :key="link.key" class="footer-link">{{ $t(link.key) }}</span>
                        </div>
                        <div class="links-row">
                            <span v-for="link in quickLinksRow2" :key="link.key" class="footer-link">{{ $t(link.key) }}</span>
                        </div>
                    </div>
                    <ul class="quick-links-list">
                        <li>{{ $t('footer.aboutUs') }}</li>
                        <li>{{ $t('footer.promotions') }}</li>
                        <li>{{ $t('footer.vipClub') }}</li>
                        <li>{{ $t('footer.responsibleGaming') }}</li>
                        <li>{{ $t('footer.terms') }}</li>
                        <li>{{ $t('footer.privacyPolicy') }}</li>
                    </ul>
                </div>
                <div class="footer-divider-v"></div>
                <div class="footer-divider-h"></div>
                <div class="footer-col">
                    <h4>{{ $t('footer.paymentMethod') }}</h4>
                    <div class="payment-row">
                        <img :src="$asset('images/payment/pay19.png')" alt="pay19" />
                    </div>
                    <div class="payment-row">
                        <img :src="$asset('images/payment/pay16.png')" alt="pay16" />
                        <img :src="$asset('images/payment/pay17.png')" alt="pay17" />
                        <img :src="$asset('images/payment/pay18.png')" alt="pay18" />
                    </div>
                    <div class="payment-row">
                        <img :src="$asset('images/payment/pay20.png')" alt="pay20" />
                        <img :src="$asset('images/payment/pay21.png')" alt="pay21" />
                        <img :src="$asset('images/payment/pay46.png')" alt="pay46" />
                    </div>
                </div>
                <div class="footer-divider-v"></div>
                <div class="footer-divider-h"></div>
                <div class="footer-col">
                    <h4>{{ $t('footer.supports') }}</h4>
                    <ul class="support-list">
                        <li>
                            <img :src="$asset('images/social/facebook.png')" alt="chat" />
                            <span>{{ $t('footer.liveChat') }}</span>
                        </li>
                        <li>
                            <img :src="$asset('images/social/telegram.png')" alt="telegram" />
                            <span>Telegram</span>
                        </li>
                        <li>
                            <img :src="$asset('images/social/whatsapp.png')" alt="whatsapp" />
                            <span>Whatsapp</span>
                        </li>
                        <li>
                            <img :src="$asset('images/social/twitter.png')" alt="twitter" />
                            <span>Support@Infinity88.com</span>
                        </li>
                    </ul>
                </div>
                <!-- <div class="footer-divider-v"></div> -->
                <div class="footer-divider-h"></div>
                <!-- <div class="footer-col">
                    <h4 class="title-desktop">{{ $t('footer.downloadApp') }}</h4>
                    <h4 class="title-stacked">About Infinity88</h4>
                    <div class="app-download">
                        <div class="store-btns">
                            <img :src="$asset('images/misc/dow-android.png')" alt="App Store" />
                            <img :src="$asset('images/misc/dow-ios.png')" alt="Google Play" />
                        </div>
                        <img class="qr-code" :src="$asset('images/misc/qr.png')" alt="QR Code" />
                    </div>
                    <p class="footer-about-desc">{{ $t('footer.description') }}</p>
                </div> -->
            </div>
            <div class="footer-bottom">
                <div class="footer-line"></div>
                <p>{{ $t('footer.copyright') }}</p>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'TheFooter',
    data() {
        return {
            quickLinksRow1: [
                { key: 'footer.aboutUs' },
                { key: 'footer.contactUs' },
                { key: 'footer.terms' },
                { key: 'footer.faq' }
            ],
            quickLinksRow2: [
                { key: 'footer.affiliate' },
                { key: 'footer.sponsor' },
                { key: 'footer.blog' }
            ]
        };
    }
};
</script>

<style lang="scss" scoped>
.the-footer {
    background: var(--surface-1);
    border-top: 1px solid var(--border-strong); // unique footer border
    display: flex;
    justify-content: space-around;
}

.footer-inner {
    flex: 1;
    min-width: 0;
    margin-left: var(--sidebar-width, 64px);
    max-width: 1376px;
    padding: 32px 88px;
    transition: margin-left 0.3s ease;
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media (max-width: 1213px) {
        padding: 24px 32px;
    }

    @media (max-width: 768px) {
        margin-left: 0;
        padding: 20px 16px;
    }
}

/* ── Desktop >1213px: horizontal 4-col ── */
.footer-main {
    display: flex;
    align-items: flex-start;
    gap: 48px;
    justify-content: center;

    @media (max-width: 1213px) {
        flex-direction: column;
        gap: 16px;
    }
}

.footer-col {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;

    @media (max-width: 1213px) {
        flex: none;
        width: 100%;
    }

    h4 {
        margin: 0;
        color: var(--text);
        font-weight: 700;
        font-size: 16px;
        line-height: 20px;

        @media (max-width: 1213px) {
            font-size: 14px;
        }
    }
}

/* Vertical divider: desktop only */
.footer-divider-v {
    width: 1px;
    background: var(--border-strong);
    align-self: stretch;
    flex-shrink: 0;

    @media (max-width: 1213px) {
        display: none;
    }
}

/* Horizontal divider: stacked only */
.footer-divider-h {
    display: none;
    width: 100%;
    height: 0;
    border-top: 1px solid color-mix(in srgb, var(--white) 15%, transparent);

    @media (max-width: 1213px) {
        display: block;
    }
}

/* Quick links: pill style shown only in stacked mode */
.quick-links {
    display: none;
    flex-direction: column;
    gap: 8px;

    @media (max-width: 1213px) {
        display: flex;
    }
}

/* List style shown only in desktop horizontal mode */
.quick-links-list {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (max-width: 1213px) {
        display: none;
    }

    li {
        color: var(--text);
        font-size: 14px;
        line-height: 20px;
        cursor: pointer;

        &:hover {
            color: var(--title-to);
        }
    }
}

.links-row {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.footer-link {
    border-left: 2px solid var(--accent-light);
    padding: 2px 10px;
    color: var(--text);
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    white-space: nowrap;
    cursor: pointer;
}

.payment-row {
    display: flex;
    align-items: center;
    gap: 8px;

    img {
        height: 20px;
        width: auto;
        object-fit: contain;
    }
}

.support-list {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;

    li {
        display: flex;
        align-items: center;
        gap: 8px;

        img {
            width: 24px;
            height: 24px;
            object-fit: contain;
            flex-shrink: 0;
        }

        span {
            color: var(--text);
            font-size: 14px;
            line-height: 20px;
        }
    }
}

/* Title shown in desktop horizontal mode */
.title-desktop {
    @media (max-width: 1213px) {
        display: none !important;
    }
}

/* Title shown in stacked mode */
.title-stacked {
    display: none;

    @media (max-width: 1213px) {
        display: block;
    }
}

.app-download {
    display: flex;
    gap: 16px;
    align-items: flex-start;

    @media (max-width: 1213px) {
        display: none;
    }

    .store-btns {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 88px;

        img {
            width: 100%;
            height: auto;
        }
    }

    .qr-code {
        width: 88px;
        height: 88px;
        object-fit: cover;
    }
}

.footer-about-desc {
    font-size: 12px;
    color: var(--text);
    line-height: 18px;
    margin: 0;
    display: none;

    @media (max-width: 1213px) {
        display: block;
    }
}

.footer-bottom {
    display: flex;
    flex-direction: column;
    gap: 8px;

    p {
        margin: 0;
        color: var(--text);
        font-size: 14px;
        font-weight: 700;
        line-height: 20px;
    }
}

.footer-line {
    height: 1px;
    background: var(--border-strong);
    width: 100%;
}
</style>
